<template>
    <div>
        <div class="rates_block" v-if="!isBooking">
            <div class="summary-details p-3 card-header font-14 bg-white">
                <strong class="mb-2 d-block">
                    <span class="font-icons icons-hotel"></span>
                    {{ __('messages.rooms-title') }} ({{ summary.roomsTotal }})
                </strong>
                <ul class="list-dots mb-0">
                    <li v-for="rm in listrooms" :key="rm.room.id">
                        <div class="d-flex">
                            <div class="mr-2 font-14">{{ rm.room.quantity }}x</div>
                            <div>
                                <p class="m-0 font-12">{{ rm.room.name }}</p>
                                <p class="text-success m-0 font-12">{{ __('mealplans.' + rm.rate.mealPlan) }}</p>
                                <div v-if="rm.rate.cancellation.isCancellationFree" class="font-12">
                                    <span class="text-success">
                                        {{ __('messages.free_cancellation_room') }}
                                    </span>
                                    <span class="text-muted">
                                        {{ __('messages.reservation_until_room') }}
                                        {{ rm.rate.cancellation.untilDateCancellation | date('D MMM YYYY') }}
                                    </span>
                                </div>
                                <div class="text-muted font-12" v-else>
                                    {{ __('messages.no_refundable') }}
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <hr class="border-row my-0" />

        <!-- Sección del descuento con estilo verde -->
        <div class="container-discount" v-if="discountStore.discountAmount">
            <label class="text-title">
                <span class="icons-label-right icon"></span>
                {{
 selectedDiscountTitle || (discountStore.discountApplicable ? __('messages.discount_title_2') :
                    __('messages.discount_title'))
                }}
            </label>
            <div class="d-flex align-items-center text-subtitle form-check m-0">
                <input class="form-check-input cursor-pointer" type="checkbox" id="discount-check"
                       name="discount-check-name" v-model="discountStore.discountApplicable" @change="onDiscountChange">
                <label class="form-check-label cursor-pointer" for="discount-check">
                    <span v-if="!discountStore.discountApplicable">
                        {{ __('messages.discount_subtitle') }} <span class="price"> <currency-display :amount="discountStore.discountAmount" :showCurrencyCode="true" :applyDecimals="true"></currency-display> </span> {{
                                __('messages.discount_subtitle_2')
                        }}
                    </span>
                    <span v-if="discountStore.discountApplicable">
                        {{ __('messages.discount_applicable') }} <span class="price"> <currency-display :amount="discountStore.discountAmount" :showCurrencyCode="true" :applyDecimals="true"></currency-display> </span>
                    </span>
                </label>
            </div>
        </div>
        <hr class="border-row my-0" />
        <div class="rates_block">
            <div class="summary-details p-3 card-header font-14 bg-level1 border-0">
                <div class="row mb-3">
                    <div class="col-7 d-flex justify-content-start">
                        {{ summary.roomsTotal }} {{
 summary.roomsTotal > 1 ? __('messages.rooms') : __('messages.room')
                        }},
                        {{ summary.days }} {{ summary.days > 1 ? __('messages.nights') : __('messages.night') }}
                    </div>
                    <div class="col-5 d-flex justify-content-end">
                        <currency-display :amount="summary.totalRate.amount" :showCurrencyCode="true" :applyDecimals="true"></currency-display>
                    </div>
                </div>
                <div class="row">
                    <div class="col-7 d-flex justify-content-start">
                        {{ __('messages.taxes_and_fees') }}
                    </div>
                    <div class="col-5 d-flex justify-content-end" v-if="summary.totalRate.totalTaxes > 0">
                        <currency-display :amount="summary.totalRate.totalTaxes" :showCurrencyCode="true" :applyDecimals="true"></currency-display>
                    </div>
                    <div class="col-5 d-flex justify-content-end"
                         v-if="summary.totalRate.hasTaxes && summary.totalRate.totalTaxes == 0">
                        {{ __('messages.tax_include') | capitalising }}
                    </div>
                    <div class="col-5 d-flex justify-content-end"
                         v-if="!summary.totalRate.hasTaxes && summary.totalRate.totalTaxes == 0">
                        {{ __('messages.tax_no_include') | capitalising }}
                    </div>
                </div>
            </div>

            <hr class="border-row my-0" v-if="!summary.totalRate.bookNowPayLater.isBookNowPayLater" />

            <div class="row pt-2 card-header-bg-custom bg-level1"
                 v-if="!summary.totalRate.bookNowPayLater.isBookNowPayLater">
                <div class="col-6 d-flex justify-content-start my-2">
                    <span class="font-14 font-weight-bold">{{ paymentMessage }}</span>
                </div>
                <div class="col-6 d-flex justify-content-end my-2">
                    <span class="h6 font-weight-bold">
                        <currency-display :amount="summary.totalRate.totalAmount" :showCurrencyCode="true" :applyDecimals="true"></currency-display>
                    </span>
                </div>
            </div>

            <hr class="border-row my-0"
                v-if="summary.totalRate.breakdownExcluded.length > 0 && summary.rate.collectType == 2" />

            <div class="summary-details p-3 card-header font-14 bg-level1"
                 v-if="summary.totalRate.breakdownExcluded.length > 0 && summary.rate.collectType == 2">
                <div class="row mb-3">
                    <div class="col-7 d-flex justify-content-start">
                        {{ __('messages.resort-fee') }}
                    </div>
                    <div class="col-5 d-flex justify-content-end">
                        <currency-display :amount="breakdownExcludedTotal" :showCurrencyCode="true" :applyDecimals="true"></currency-display>
                    </div>
                </div>
                <div class="row">
                    <div class="col-7 d-flex justify-content-start">
                        {{ __('messages.pay-accommodation-title') }}
                    </div>
                    <div class="col-5 d-flex justify-content-end">
                        <currency-display :amount="breakdownExcludedTotal + summary.totalRate.totalAmount" :showCurrencyCode="true" :applyDecimals="true"></currency-display>
                    </div>

                </div>
            </div>

            <hr class="border-row my-0"
                v-if="summary.rate.collectType == 2 && !(getExchange.currency == summary.totalRate.hotelCollectCurrency && ((summary.totalRate.hotelCollectAmount  + this.summary.totalRate.breakdownExcluded.reduce((accum, item) => accum + item.originalAmount, 0)) == (summary.totalRate.totalAmount + this.summary.totalRate.breakdownExcluded.reduce((accum, item) => accum + item.amount, 0))))" />
            
            <div class="p-3 d-flex g-8" v-if="summary.rate.collectType == 2 && !(getExchange.currency == summary.totalRate.hotelCollectCurrency && ((summary.totalRate.hotelCollectAmount  + this.summary.totalRate.breakdownExcluded.reduce((accum, item) => accum + item.originalAmount, 0)) == (summary.totalRate.totalAmount + this.summary.totalRate.breakdownExcluded.reduce((accum, item) => accum + item.amount, 0))))">
                <i class="icons-info font-18"></i>
                <p class="mb-0 font-14">
                    {{ getExchange.currency != summary.totalRate.hotelCollectCurrency ? __('messages.messagge-fee', [getExchange.currency]) : __('messages.messagge-fee', [' ']) }}
                    <strong v-if="getExchange.currency === summary.totalRate.hotelCollectCurrency">
                        <currency-display :amount="summary.totalRate.hotelCollectAmount + this.summary.totalRate.breakdownExcluded.reduce((accum, item) => accum + item.amount, 0)" :showCurrencyCode="true" :applyDecimals="true" :currencyCode="summary.totalRate.hotelCollectCurrency" :applyConvertion="false" :applySymbol="true"></currency-display>
                    </strong>
                    <strong v-else>
                        <currency-display :amount="summary.totalRate.hotelCollectAmount + this.summary.totalRate.breakdownExcluded.reduce((accum, item) => accum + item.originalAmount, 0)" :showCurrencyCode="true" :applyDecimals="true" :currencyCode="summary.totalRate.hotelCollectCurrency" :applyConvertion="false" :applySymbol="true"></currency-display>
                    </strong>
                    {{ __('messages.messagge-fee-2') }}
                </p>
            </div> 

        </div>
    </div>
</template>

<script>
    const site = window.__pt.settings.site;
    import { useDiscountStore } from '../../stores/discount';
    import { useExchangeRateStore } from "../../stores/exchange";
    import { storeToRefs } from 'pinia';
    import { StorageService } from '../../../vue/services/StorageService';
    export default {
        setup() {
            const exchangeStore = useExchangeRateStore();
            const discountStore = useDiscountStore();

            const { getExchange } = storeToRefs(exchangeStore);
            return { discountStore, getExchange };
        },
        data() {
            return {
                currencySite: window.__pt.settings.site.currencySymbol.replace(/[\$\s]/g, ''),
                currencySymbol: window.__pt.settings.site.currency,
                selectedDiscountTitle: null,
            };
        },
        props: {
            summary: Object,
            isBooking: {
                type: Boolean,
                default: false
            },
            listrooms: Array
        },
        computed: {
            hasTaxExcluded() {
                return this.summary.rate.breakdownExcluded.some(item => item.title === 'TaxExcluded' && this.summary.rate.country == 'CO');
            },
            breakdownExcludedTotal() {
                return this.summary.totalRate.breakdownExcluded.reduce((accum, item) => accum + item.amount, 0);
            },
            showTaxesAndFees() {
                return this.summary.totalRate.totalTaxes > 0 || (this.summary.totalRate.hasTaxes && this.summary.totalRate.totalTaxes === 0 && !this.hasTaxExcluded);
            },
            paymentMessage() {
                if (this.summary.rate.collectType == 2) {
                    return this.summary.totalRate.breakdownExcluded.length > 0
                        ? this.__('messages.price')
                        : this.__('messages.pay-accommodation-title');
                }
                return this.__('messages.total');
            },
            discountTitles() {
                return site.discountTitles || [];
            },
        },
        mounted() {
            this.loadDiscountTitle();
        },
        methods: {
            loadDiscountTitle() {
                const savedTitle = StorageService.getSession('selectedDiscountTitle');
                if (savedTitle) {
                    this.selectedDiscountTitle = savedTitle;
                } else {
                    this.selectRandomDiscountTitle();
                }
            },
            selectRandomDiscountTitle() {
                if (this.discountTitles.length > 0) {
                    const randomIndex = Math.floor(Math.random() * this.discountTitles.length);
                    this.selectedDiscountTitle = this.discountTitles[randomIndex];
                    StorageService.setSession('selectedDiscountTitle', this.selectedDiscountTitle);
                }
            },
            onDiscountChange() {
                this.$emit('discount-changed', this.discountStore.discountApplicable);
            }
        }
    }
</script>
